import { CLIENT_GET_INVESTMENT_STATE } from "@/graphql/operations/client.queries";
import { useQuery } from "@apollo/client";

export function useInvestmentPageState() {
  const { data } = useQuery(CLIENT_GET_INVESTMENT_STATE, { fetchPolicy: "cache-only" });

  return data?.investmentPageState;
}
